export default {"src":"/_next/static/media/Left.ceb956ba.svg","height":54,"width":29,"blurWidth":0,"blurHeight":0};